import React from 'react';
import './checkout.css';

import Subtotal from './Subtotal';
import { connect } from 'react-redux';
import BasketItem from './BasketItem';


const mapStateToProps = (state) => {
  return {
    Basket: state.Basket,
    user: state.User,
  };
};


function Basket(props) {
  const Total = 2000 * props.Basket.length;
  // console.log(props.Basket);
  return (
    <div className="checkout">
      <div className="checkout_left">
        <img
          className="checkout_ad"
          src="https://images-na.ssl-images-amazon.com/images/G/02/UK_CCMP/TM/OCC_Amazon1._CB423492668_.jpg"
          alt=""
        />
        <h2 className="checkout_title">
          HI {props.user?.user?.email} Your shopping Basket
        </h2>

        <div className="product_row">
 
            {props?.Basket?.map((item, index) => {
              return (
                <BasketItem item={item} key={index} index={index}></BasketItem>

                //   <Card className={classes.root} key={index}>
                //     <CardActionArea>
                //       <CardMedia
                //         className={classes.media}
                //         image={item.image}
                //         title={item.title}
                //       />
                //       <CardContent>
                //         <Typography gutterBottom variant="div" component="div">
                //           <Rating
                //             name="hover-feedback"
                //             value={item.rating}
                //             precision={0.5}
                //             // onChange={(event, newValue) => {
                //             //   setValue(newValue);
                //             // }}
                //             // onChangeActive={(event, newHover) => {
                //             //   setHover(newHover);
                //             // }}
                //           />
                //         </Typography>
                //         <Typography gutterBottom variant="h5" component="h2">
                //           {item.title}
                //         </Typography>
                //         <Typography
                //           variant="body2"
                //           color="textSecondary"
                //           component="p"
                //         >
                //           {item.discription}
                //         </Typography>
                //         <Typography
                //           variant="body2"
                //           color="textSecondary"
                //           component="p"
                //         >
                //           Price :2000
                //         </Typography>
                //       </CardContent>
                //     </CardActionArea>
                //     <CardActions>
                //       {/* <Button
                //   size="small"
                //   color="primary"
                //   onClick={() => {
                //     addToBasket();
                //   }}
                // >
                //   Add to basket
                // </Button> */}
                //     </CardActions>
                //   </Card>
              );
            })}
         
        </div>
      </div>

      <div className="checkout_right">
        <Subtotal Total={Total} count={props.Basket.length} />
      </div>
    </div>
  );
}

export default connect(mapStateToProps)(Basket);
